import Vue from "vue";
import { addClass, getStyle, removeClass } from "./dom";
import Loading from "./index.vue";
import { getDefaultProp } from "../../../utils";

/**
 * 为loading组件创建constructor动态注入
 */
const LoadingConstructor = Vue.extend(Loading);

const togglePosition = (el, binding) => {
  if (binding.value) {
    const originalPosition = getStyle(el, "position");
    if (originalPosition !== "absolute" && originalPosition !== "fixed") {
      addClass(el, "sj-loading-parent--relative");
    }
  } else {
    setTimeout(() => {
      if (el && el.instance && el.instance.visible) return;
      removeClass(el, "sj-loading-parent--relative");
    }, 400);
  }
};

const getDefaultTheme = () => {
  return getDefaultProp(
    Vue.prototype.$SJ_COMPONENTS_CONFIG?.Loading?.theme,
    "1"
  );
};

/**
 * 为loading组件配置directive选项
 */
const loadingDirective = {
  bind(el, binding) {
    const text = el.getAttribute("sj-loading-text") || "Loading...";
    const theme = el.getAttribute("sj-loading-theme") || getDefaultTheme();
    const instance = new LoadingConstructor({
      data: {
        text,
        theme
      }
    });
    instance.$mount();
    el.instance = instance;
    el.mask = instance.$el;
    el.appendChild(el.mask);
    binding.value && (el.instance.visible = binding.value);
    togglePosition(el, binding);
  },
  update(el, binding) {
    el.instance.setText(el.getAttribute("sj-loading-text") || "Loading...");
    el.instance.setTheme(
      el.getAttribute("sj-loading-theme") || getDefaultTheme()
    );
    if (binding.oldValue !== binding.value) {
      el.instance.visible = binding.value;
      togglePosition(el, binding);
    }
  },
  unbind(el) {
    if (el.domInserted) {
      el.mask && el.mask.parentNode && el.mask.parentNode.removeChild(el.mask);
      togglePosition(el, { value: false });
    }
  }
};

export default loadingDirective;
